/**
 * Action types for pcs functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of pcs.
 */

// Get pcs constants
export const PCS_REQUEST_GET = 'PCS_REQUEST_GET';
export const PCS_RESPONSE_GET_SUCCESS = 'PCS_RESPONSE_GET_SUCCESS';
export const PCS_RESPONSE_GET_FAIL = 'PCS_RESPONSE_GET_FAIL'
